import {
  CodeOutlined,
  DownloadOutlined,
  GiftOutlined,
  IssuesCloseOutlined,
  MoneyCollectOutlined,
  SmileOutlined,
  SoundOutlined,
  TeamOutlined,
} from "@ant-design/icons";

import { PATH } from "./path";

interface TypeHeaderNavLinkList {
  to: string;
  link: string;
  icon: any;
  key: number;
}

const HEADER_NAV_LINK_LIST: TypeHeaderNavLinkList[] = [
  { to: PATH.info.faq, link: "FAQ", icon: CodeOutlined, key: 1 },
  {
    to: PATH.info.responsibleGaming,
    link: "Responsive Gaming",
    icon: IssuesCloseOutlined,
    key: 2,
  },
  {
    to: PATH.info.bettingRules,
    link: "Rules",
    icon: MoneyCollectOutlined,
    key: 3,
  },
  { to: PATH.info.about, link: "About", icon: SmileOutlined, key: 4 },
  { to: PATH.newsPage, link: "News", icon: SoundOutlined, key: 5 },
  { to: PATH.bonusPage, link: "Bonuses", icon: GiftOutlined, key: 6 },
  {
    to: PATH.user.loyaltyProgram,
    link: "Member VIP",
    icon: TeamOutlined,
    key: 7,
  },
  {
    to: "",
    link: "Download App",
    icon: DownloadOutlined,
    key: 8,
  },
];
export default HEADER_NAV_LINK_LIST;
